import React, { useState } from 'react'
import { Link, useNavigate,useLocation } from 'react-router-dom'
import Modal from 'react-modal';



function Sidebar() {
	const navigate = useNavigate();
	const location = useLocation();
	const isActive = (path) => location.pathname.startsWith(path);
	const [logoutModal, setLogoutModal] = useState(false);

	const handleLogout = () => {
		localStorage.clear();
		navigate('/')
	  }	

	  const closeModal = (type) => {
		setLogoutModal(false);
	  };

	  const openModal = (id) => {
        setLogoutModal(true);
      };

	return (
	<div className='left-bar'>
		<ul>
		<li className={isActive('/admin/user-management') ? 'active' : ''}><Link to='/admin/user-management'><img src={window.getPublicUrl('/assets/images/user-management.svg')} alt="" />User Management</Link></li>
		<li className={isActive('/admin/venue') ? 'active' : ''}><Link to='/admin/venue'><img src={window.getPublicUrl('/assets/images/venue.svg')} alt="" />Venue</Link></li>
		<li className={isActive('/admin/offer') ? 'active' : ''}><Link to='/admin/offer'><img src={window.getPublicUrl('/assets/images/offer.svg')} alt="" />Offer</Link></li>
		<li className={isActive('/admin/event') ? 'active' : ''}><Link to='/admin/event'><img src={window.getPublicUrl('/assets/images/offer.svg')} alt="" />Event</Link></li>
		{/* <li className={isActive('/admin/subscription') ? 'active' : ''}><Link to='/admin/subscription'><img src={window.getPublicUrl('/assets/images/content-management.svg')} alt="" />Subscriptions</Link></li>
		<li className={isActive('/admin/meditaion') ? 'active' : ''}><Link to='/admin/meditaion'><img src={window.getPublicUrl('/assets/images/analytic-dashboard.svg')} alt="" />Meditation </Link></li>
		<li className={isActive('/admin/support') ? 'active' : ''}><Link to='/admin/support'><img src={window.getPublicUrl('/assets/images/notification-management.svg')} alt="" />Support</Link></li> */}
		<li><Link onClick={() => {openModal()}}><img src={window.getPublicUrl('/assets/images/log-out.svg')} alt="" />Log Out</Link></li>
		</ul>

		<Modal
        isOpen={logoutModal}
        onRequestClose={closeModal}
        contentLabel="Delete Modal"
        shouldCloseOnOverlayClick={false}
        ariaHideApp={false}
        overlayClassName={`modal-overlay add-category delete logout `} 
        portalClassName="logout-modal-lg">
           <div className='detail-page-modal'>
        
        <span> <img src={window.getPublicUrl('/assets/images/logout.svg')} /></span>
        <h2>Are you sure you want to logout?</h2>
        <p></p>
        <div className="modal-footer">
          <button className='cancel' onClick={closeModal}>Cancel</button>
          <button className='save' onClick={handleLogout} >
            Yes, I'm sure</button>
        </div>
		</div>
      </Modal>
	</div>
	);
}

export default Sidebar